import Page from "@/components/layout/Page";

export default function CareHomes() {
  return (
    <div className="min-h-screen overflow-hidden bg-gradient-to-b from-[#020817] via-[#04151F] to-[#020817] text-slate-50">
      <Page>
        <section className="w-full pb-24">
          <div className="max-w-[1280px] mx-auto px-6">
          <h1 className="text-[54px] leading-[1.1] font-bold mb-6 page-title-gradient">Care Homes</h1>
          
          <div className="space-y-6 max-w-3xl">
            <p className="text-xl text-muted-foreground leading-relaxed">
              Sensory solutions designed to support wellbeing and engagement in care home environments.
            </p>
            
            <p className="text-lg leading-relaxed">
              Samboards sensory products provide meaningful engagement for care home residents, particularly those living with dementia, mobility challenges, or other age-related conditions. Our tactile boards offer a calming, non-threatening activity that can be enjoyed individually or as part of group activities.
            </p>
            
            <p className="text-lg leading-relaxed">
              The sensory engagement provided by our products helps reduce anxiety and agitation, common challenges in care settings. Residents can explore different textures at their own pace, providing comfort and stimulation while supporting cognitive function and fine motor skills.
            </p>
            
            <p className="text-lg leading-relaxed">
              Our products are easy to clean and maintain, making them practical for busy care environments. They're durable enough for daily use and can be incorporated into activity programmes, one-to-one sessions, or left available for residents to use whenever they feel the need.
            </p>
            
            <p className="text-lg leading-relaxed">
              Many care homes use Samboards as part of their approach to person-centred care, recognising that sensory engagement is vital for quality of life and emotional wellbeing in residential settings.
            </p>
          </div>
        </div>
      </section>
      </Page>
    </div>
  );
}
